/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFilterViewRequest
 */
export interface UpdateFilterViewRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFilterViewRequest
     */
    view_key?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFilterViewRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFilterViewRequest
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFilterViewRequest
     */
    filters?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFilterViewRequest
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the UpdateFilterViewRequest interface.
 */
export function instanceOfUpdateFilterViewRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateFilterViewRequestFromJSON(json: any): UpdateFilterViewRequest {
    return UpdateFilterViewRequestFromJSONTyped(json, false);
}

export function UpdateFilterViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFilterViewRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'view_key': !exists(json, 'view_key') ? undefined : json['view_key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'filters': !exists(json, 'filters') ? undefined : json['filters'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
    };
}

export function UpdateFilterViewRequestToJSON(value?: UpdateFilterViewRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'view_key': value.view_key,
        'name': value.name,
        'description': value.description,
        'filters': value.filters,
        'is_default': value.is_default,
    };
}

